export default __webpack_public_path__ + "static/buildon_sg_2019-393b607baed8b2a5f92a0d5c136a2d86.jpg";